var $ = require('jquery');
var Urank = require('../../index');
var data = require('./test_data');
var options = require('./urank_options');

module.exports = (function() {
    
    var fontSizeMapping = [
        { 'minwidth': 1530, 'fontsize': "14px" },
        { 'minwidth': 1280, 'fontsize': "13px" },
        { 'minwidth': 1025, 'fontsize': "12px" },
        { 'minwidth': 768 , 'fontsize': "10px" },
        { 'minwidth': 0   , 'fontsize': "8px" }
    ];
    	

	$(window).on('resize', function() {
		var containerWidth = $('.main-panel').width();
		
		for(var i=0, isFound=false; i<fontSizeMapping.length && !isFound; i++) {
			if(containerWidth >= fontSizeMapping[i].minwidth) {
				$('.main-panel').css('font-size', fontSizeMapping[i].fontsize);
				isFound = true;
				console.log('container width = ' + containerWidth + 'px; font-size = ' + fontSizeMapping[i].fontsize+'em');
			}
		}


	});


    window.onload = function(){
        $.getJSON('./input/publications.json', function(d) {          
            var urank = new Urank(options)
            urank.load(d);
            $(window).trigger('resize');
        });
    }



})();


//////////////////
// WEBPACK FOOTER
// ./js/main.js
// module id = 146
// module chunks = 0